import routes from './routes';

const SEOMetaInfo = {
  [routes.home]: {
    title: 'Register as an Employer | Post IT Jobs on VeriiPro',
    description:
      'Create an employer account on VeriiPro to post job openings, search for qualified IT professionals, and streamline your tech recruitment process.',
    image: 'https://www.veriipro.com/images/candidte-header.jpeg',
    canonical: 'https://employer.veriipro.com'
  },
  [routes.login]: {
    title: 'Employer Login | Access Your VeriiPro Recruiting Account',
    description:
      'Log in to your VeriiPro employer account to manage job postings, review applications, and connect with top IT talent for your organization.',
    keywords:
      'sign in, access account, user login, authentication, secure login, credentials, login page',
    image: 'https://www.veriipro.com/images/candidte-header.jpeg',
    canonical: 'https://employer.veriipro.com/login/'
  },
  [routes.forgotPassword]: {
    title: 'Forgot Password | VeriiPro',
    description: 'Reset your VeriiPro account password',
    keywords: 'forgot password, reset password, account recovery'
  },

  [routes.dashboard]: {
    title: 'Dashboard | Manage Your IT Recruitment on VeriiPro',
    description: 'Employer dashboard - Manage your recruitment activities',
    keywords: 'dashboard, employer, recruitment management'
  },
  [routes.jobs + routes.myJobs]: {
    title: 'Jobs | VeriiPro',
    description: 'Manage your job postings and applications',
    keywords: 'jobs, job postings, recruitment'
  },
  [routes.postJob]: {
    title: 'Post Job | VeriiPro',
    description: 'Post a new job opening on VeriiPro',
    keywords: 'post job, job posting, recruitment'
  },
  [routes.draftJob]: {
    title: 'Draft job |VeriiPro',
    description: 'Draft job on VeriiPro',
    keywords: 'draft job, job posting, recruitment'
  },
  [routes.candidateSearch]: {
    title: 'Search Candidates | VeriiPro',
    description: 'Search and find qualified candidates for your positions',
    keywords: 'candidate search, recruitment, hiring'
  },
  [routes.savedCandidate]: {
    title: 'Saved Candidates | VeriiPro',
    description: 'View and manage your saved candidates',
    keywords: 'saved candidates, favorites, recruitment'
  },
  [routes.downloadedCandidate]: {
    title: 'Downloaded Candidates | VeriiPro',
    description: 'View and manage your downloaded candidates',
    keywords: 'downloaded candidates, resumes, recruitment'
  },
  [routes.candidateRecentSearchHistory]: {
    title: 'Recent Search history | VeriiPro',
    description: 'View your recent search history',
    keywords: 'search history, recent searches, recruitment'
  },
  [routes.applications]: {
    title: 'Applications | VeriiPro',
    description: 'View and manage job applications',
    keywords: 'applications, candidates, recruitment'
  },
  [routes.updateProfile]: {
    title: 'Profile | VeriiPro',
    description: 'Manage your employer profile',
    keywords: 'profile, employer, account'
  },
  [routes.updateCompanyProfile]: {
    title: 'Company Profile | VeriiPro',
    description: 'Manage your company profile',
    keywords: 'company profile, employer, account'
  },
  [routes.viewMessages]: {
    title: 'Messages | VeriiPro',
    description: 'View and manage messages',
    keywords: 'messages, notifications, communication'
  },
  [routes.teamProfiles]: {
    title: 'Team Profiles | VeriiPro',
    description: 'Manage your team profiles',
    keywords: 'team profiles, manage team, employer'
  },
  [routes.notFound]: {
    title: 'Error 404 - Page Not Found',
    description: 'The page you are looking for could not be found',
    keywords: '404, page not found'
  },
  // Default fallback
  default: {
    title: 'VeriiPro | Find Top IT Jobs & Talent in the US',
    description:
      'Discover premier IT job opportunities and top tech talent with VeriiPro. Connect with leading companies and advance your career in the US tech industry.',
    keywords: 'recruitment, hiring, jobs, employers, candidates'
  }
};

export default SEOMetaInfo;
